import React from 'react';
import { useStandardResourceNotFoundState } from '../../../../entities/view-manager-standard/resource-not-found';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';

export const ResourceNotFoundPage: React.FunctionComponent = () => {
  const notFoundState = useStandardResourceNotFoundState();

  return (
    <BwjViewManager
      state={BwjViewState.PageNotFound}
      pageNotFoundState={notFoundState}
    />
  );
};
